<template>
  <button
      v-if="coachBill.coachingType === 'private_coaching'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="cancellationBill(coachBill.id, 'private_coaching')">
    <i v-if="icon" class="fa-solid fa-ban me-1"></i>{{ $t('general.cancellation') }}
  </button>
  <button
      v-if="
        coachBill.coachingType === 'group_coaching' &&
        coachBill.billingType === 'pauschalbetrag'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="cancellationBill(coachBill.id, 'group_coaching_pauschal')">
    <i v-if="icon" class="fa-solid fa-ban me-1"></i>{{ $t('general.cancellation') }}
  </button>
  <button
      v-else-if="
          coachBill.coachingType === 'group_coaching' &&
          coachBill.billingType !== 'pauschalbetrag'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="cancellationBill(coachBill.id, 'group_coaching_hourly_wages')">
    <i v-if="icon" class="fa-solid fa-ban me-1"></i>{{ $t('general.cancellation') }}
  </button>
  <button
      v-if="coachBill.coachingType === 'assisted_living_coaching'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="cancellationBill(coachBill.id, 'assisted_living_coaching')">
    <i v-if="icon" class="fa-solid fa-ban me-1"></i>{{ $t('general.cancellation') }}
  </button>
  <button
      v-if="coachBill.coachingType === 'case_management_coaching'"
      class="btn btn-primary"
      :class="{ 'btn-padded': icon }"
      @click.prevent="cancellationBill(coachBill.id, 'case_management_coaching')">
    <i v-if="icon" class="fa-solid fa-ban me-1"></i>{{ $t('general.cancellation') }}
  </button>
</template>

<script setup>
import { CloseToast } from '@/components/VueToast';
import { defineEmits, defineProps } from 'vue';

const emit  = defineEmits([ 'billCancellation' ]);
const props = defineProps({
  coachBill: {
    type: Object,
    required: true,
  },
  icon: {
    type: Boolean,
    default: false,
  },
});

const cancellationBill = (id, billType) => {
  CloseToast();
  emit('billCancellation', id, billType);
};

</script>

<style scoped>
.btn-padded {
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
